//
// locales/vanilla/el.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/el.json';
import localeData from 'react-intl/locale-data/el.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
